import axios from 'axios';
import _ from 'lodash';


import { getPasswordResetUrl } from '../configuration/selectors';
import { getEphemeralCredentials } from './selectors';
import { saveCredentials, saveUser, loginSuccess } from '../authentication/actions';
import { remapKeys } from '../../utils';


// NOTE: PASSWORD_RESET_REQUEST_REQUEST?
export const types = {
  PASSWORD_RESET_REQUEST_REQUEST: 'passwordReset/PASSWORD_RESET_REQUEST_REQUEST',
  PASSWORD_RESET_REQUEST_SUCCESS: 'passwordReset/PASSWORD_RESET_REQUEST_SUCCESS',
  PASSWORD_RESET_REQUEST_FAILURE: 'passwordReset/PASSWORD_RESET_REQUEST_FAILURE',

  PASSWORD_RESET_REQUEST: 'passwordReset/PASSWORD_RESET_REQUEST',
  PASSWORD_RESET_SUCCESS: 'passwordReset/PASSWORD_RESET_SUCCESS',
  PASSWORD_RESET_FAILURE: 'passwordReset/PASSWORD_RESET_FAILURE',

  SET_EPHEMERAL_CREDENTIALS: 'passwordReset/SET_EPHEMERAL_CREDENTIALS',
  STORE_QUERY_PARAMS: 'passwordReset/STORE_QUERY_PARAMS',
};


export const setEphemeralCredentials = (ephemeralCredentialsWire) => {
  const wireFields = ['client_id', 'token', 'uid'];
  const wireMap = {
    client_id: 'client',
    token: 'access-token',
    uid: 'uid',
  };

  /*
  * NOTE: There is almost certainly a way to make this more readable with currying/partials
  * At the moment it is just easier to nest the calls.
   */
  const ephemeralCredentials = remapKeys(_.pick(ephemeralCredentialsWire, wireFields), wireMap);

  return {
    type: types.SET_EPHEMERAL_CREDENTIALS,
    ephemeralCredentials,
  };
};

export const storeQueryParams = (querySearch) => {
  return {
    type: types.STORE_QUERY_PARAMS,
    querySearch,
  };
};


export const requestPasswordReset = (email) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const passwordResetUrl = getPasswordResetUrl(state);

    const { host, protocol } = window.location;
    const redirectUrl = `${protocol}//${host}/password-reset`;

    const requestBody = {
      email,
      redirect_url: redirectUrl,
    };

    /* Add try/catch, Success: push success into the route
    * Error: form handles error display
     */
    await axios.post(passwordResetUrl, requestBody);
  };
};


export const resetPassword = (password, passwordConfirmation) => {
  return async (dispatch, getState, { client }) => {
    const credentialsProperties = ['access-token', 'uid', 'expiry', 'client', 'token-type'];
    const state = getState();
    const ephemeralCredentials = getEphemeralCredentials(state);
    const passwordResetUrl = getPasswordResetUrl(state);

    const requestBody = {
      password,
      password_confirmation: passwordConfirmation,
    };

    const requestConfiguration = {
      url: passwordResetUrl,
      method: 'put',
      headers: ephemeralCredentials,
      data: requestBody,
    };

    const response = await axios.request(requestConfiguration);
    const { headers, data: { data: user } } = response;
    const credentials = _.pick(headers, credentialsProperties);
    dispatch(saveUser(user));
    dispatch(saveCredentials(credentials));
    dispatch(loginSuccess());
  };
};
